module.exports = __webpack_public_path__ + "static/bgpattern-66b05e3ac1a40e0c2eadce22ad62a9d4.png";